import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type ZoomInProps = {
    className?: string;
};

const ZoomIn: FunctionComponent<ZoomInProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'zoom-in'}
            viewBox="0 0 250 250"
        >
            <path
                fill="#FFFFFF"
                d="M93.3 9C46.8 9 9 46.7 9 93.1c0 46.3 37.8 84.1 84.3 84.1s84.3-37.8 84.3-84.1C177.6 46.7 139.8 9 93.3 9z"
                fillOpacity="0.3"
            />
            <path d="M154.7 163.2l-.9.8c-16.9 14.4-38.3 22.3-60.5 22.3-51.4 0-93.2-41.7-93.2-93S41.9.2 93.2.2s93.2 41.7 93.2 93c0 23.4-8.7 45.6-24.5 62.8l-.9.9 89.1 87-6.2 6.3-89.2-87zM93.3 9.2C46.8 9.2 9 46.8 9 93.3c0 46.3 37.8 84.1 84.3 84.1s84.3-37.8 84.3-84.1c0-46.5-37.8-84.1-84.3-84.1z" />
            <polygon points="97.7,59.7 87.7,59.7 87.7,90.7 57.8,90.7 57.8,100.7 87.7,100.7 87.7,129.5 97.7,129.5 97.7,100.7 127.8,100.7 127.8,90.7 97.7,90.7" />
        </svg>
    );
};
export default ZoomIn;
